import React from 'react';
import {
  Container,
  Stack,
  VStack,
  HStack,
  Grid,
  GridItem,
} from '@/components/ui';
import { CodeBlock } from '../CodeBlock';
import { SectionWrapper } from '../SectionWrapper';

export function LayoutSection() {
  return (
    <SectionWrapper title="Layout Components">
        {/* Container */}
        <div>
          <h3 className="text-lg font-semibold mb-4">Container</h3>
          <Stack spacing={4}>
            <Container size="sm" className="bg-muted p-4 rounded">
              <p className="text-center">Small Container (max-width: 640px)</p>
            </Container>
            <Container size="md" className="bg-muted p-4 rounded">
              <p className="text-center">Medium Container (max-width: 768px)</p>
            </Container>
            <Container size="lg" className="bg-muted p-4 rounded">
              <p className="text-center">Large Container (max-width: 1024px)</p>
            </Container>
          </Stack>
          <CodeBlock>
{`<Container size="sm">
  <p>Small Container content</p>
</Container>

<Container size="lg" className="custom-class">
  <p>Large Container with custom styling</p>
</Container>`}
          </CodeBlock>
        </div>

        {/* Stack */}
        <div>
          <h3 className="text-lg font-semibold mb-4">Stack Components</h3>
          <div className="grid gap-4 md:grid-cols-2">
            <div>
              <p className="text-sm text-muted-foreground mb-2">Vertical Stack</p>
              <VStack spacing={3} className="bg-muted p-4 rounded">
                <div className="bg-card p-2 rounded text-center">Item 1</div>
                <div className="bg-card p-2 rounded text-center">Item 2</div>
                <div className="bg-card p-2 rounded text-center">Item 3</div>
              </VStack>
            </div>
            <div>
              <p className="text-sm text-muted-foreground mb-2">Horizontal Stack</p>
              <HStack spacing={3} className="bg-muted p-4 rounded">
                <div className="bg-card p-2 rounded">Item 1</div>
                <div className="bg-card p-2 rounded">Item 2</div>
                <div className="bg-card p-2 rounded">Item 3</div>
              </HStack>
            </div>
          </div>
          <CodeBlock>
{`<VStack spacing={3}>
  <div>Item 1</div>
  <div>Item 2</div>
  <div>Item 3</div>
</VStack>

<HStack spacing={3} align="center">
  <div>Item 1</div>
  <div>Item 2</div>
  <div>Item 3</div>
</HStack>`}
          </CodeBlock>
        </div>

        {/* Grid */}
        <div>
          <h3 className="text-lg font-semibold mb-4">Grid Layout</h3>
          <Grid cols={3} gap={4}>
            <GridItem className="bg-muted p-4 rounded text-center">Item 1</GridItem>
            <GridItem className="bg-muted p-4 rounded text-center">Item 2</GridItem>
            <GridItem className="bg-muted p-4 rounded text-center">Item 3</GridItem>
            <GridItem colSpan={2} className="bg-muted p-4 rounded text-center">
              Item 4 (spans 2 columns)
            </GridItem>
            <GridItem className="bg-muted p-4 rounded text-center">Item 5</GridItem>
            <GridItem colSpan={3} className="bg-muted p-4 rounded text-center">
              Item 6 (spans 3 columns)
            </GridItem>
          </Grid>
          <CodeBlock>
{`<Grid cols={3} gap={4}>
  <GridItem>Item 1</GridItem>
  <GridItem>Item 2</GridItem>
  <GridItem>Item 3</GridItem>
  <GridItem colSpan={2}>
    Item 4 (spans 2 columns)
  </GridItem>
  <GridItem>Item 5</GridItem>
  <GridItem colSpan={3}>
    Item 6 (spans 3 columns)
  </GridItem>
</Grid>`}
          </CodeBlock>
        </div>
    </SectionWrapper>
  );
}
